import { poll } from 'lib/poll';
import * as operations from 'lib/graphql/queries';
import { millisecond } from 'config/constants';
import { LatestRef } from './types';
import { SelfServiceAPI } from 'apis';

export const acceptQuote = async (ref: LatestRef) => {
  const { client, setState } = ref.current;
  const bookingId = ref.current.booking!.id;
  const amendmentId = ref.current.amendment!.id;

  setState((state) => ({ ...state, stage: 'PROCESSING' }));

  await operations.acceptAmendment(client, { variables: { bookingId, amendmentId } });

  const acceptedResult = await poll({
    requestFn: () => SelfServiceAPI.getAmendment({ bookingId, amendmentId }),
    isFinished: (result) => result.amendment.state !== 'ACCEPTING',
    timeoutMs: millisecond.MINUTE * 3,
  });

  const { amendment } = acceptedResult;

  ref.current.amendment = amendment;

  setState((state) => ({ ...state, stage: amendment.state === 'ACCEPTED' ? 'CONFIRMED' : 'REVIEW' }));

  return amendment;
};
